// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Bandeja del sidebar.
 *
 * Copia el marco de \`UserMenu.module.css\` -mismo ancho de panel, misma sombra,
 * misma animacion- para que los dos desplegables del pie se sientan del mismo
 * sitio. Lo que cambia es el contenido, no el envoltorio.
 */

.NotificationBell_trigger__TRjmz {
  border: none;
  background: transparent;
  text-align: left;
  font-family: var(--font-sans);
  /* El globo se posiciona contra este contenedor. */
  position: relative;
}
.NotificationBell_triggerOpen__Qc71v {
  background: color-mix(in srgb, var(--dylo-teal-700) 12%, transparent);
  color: var(--dylo-ink);
}

/* Globo con el conteo, encima del icono.
   Va sobre el icono y no junto a la etiqueta porque la etiqueta desaparece con el
   sidebar colapsado, que es el estado por omision. */
.NotificationBell_badge__Jktys {
  position: absolute;
  top: -5px;
  right: -7px;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: 999px;
  background: var(--dylo-orange);
  color: #fff;
  font-family: var(--font-sans);
  font-size: 10px;
  font-weight: 700;
  line-height: 16px;
  text-align: center;
  /* Contorno del color del sidebar para que el globo se separe del icono sin
     necesitar sombra. */
  box-shadow: 0 0 0 2px var(--dylo-sidebar-bg, var(--dylo-surface));
}

.NotificationBell_panel__UCTtV {
  position: fixed;
  z-index: 1200;
  width: 330px;
  /* En un teléfono angosto no pasa del ancho de la pantalla (21-oct-2026). Ver \`popoverPosition.ts\`. */
  max-width: calc(100vw - 24px);
  max-height: 60vh;
  display: flex;
  flex-direction: column;
  background: var(--dylo-surface);
  border: 1px solid var(--dylo-surface-border);
  border-radius: 14px;
  box-shadow: 0 12px 34px rgba(0, 0, 0, 0.28);
  transform-origin: bottom left;
  animation: NotificationBell_bell-in__74cQA 0.18s cubic-bezier(0.16, 1, 0.3, 1) both;
  overflow: hidden;
}

@keyframes NotificationBell_bell-in__74cQA {
  from { opacity: 0; transform: translateY(6px) scale(0.97); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

.NotificationBell_head__1NlTC {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 11px 13px;
  border-bottom: 1px solid var(--dylo-surface-border);
}
.NotificationBell_headTitle__VmCzh {
  font-family: var(--font-sans);
  font-size: 13px;
  font-weight: 700;
  color: var(--dylo-ink);
}
.NotificationBell_markAll__VFrhW {
  border: 0;
  background: transparent;
  padding: 0;
  font-family: var(--font-sans);
  font-size: 11.5px;
  font-weight: 600;
  color: var(--dylo-orange);
  cursor: pointer;
}
.NotificationBell_markAll__VFrhW:hover {
  text-decoration: underline;
}

.NotificationBell_list__EoWQD {
  overflow-y: auto;
  padding: 5px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  /* Al llegar al final de la lista, la rueda no mueve la página de atrás. */
  overscroll-behavior: contain;
  /* 🔄 15-oct-2026: la barra de la plataforma (la de los modales y las tablas), no la del navegador. */
  scrollbar-width: thin;
  scrollbar-color: color-mix(in srgb, var(--dylo-muted) 35%, transparent) transparent;
}
.NotificationBell_list__EoWQD::-webkit-scrollbar {
  width: 6px;
}
.NotificationBell_list__EoWQD::-webkit-scrollbar-track {
  background: transparent;
}
.NotificationBell_list__EoWQD::-webkit-scrollbar-thumb {
  background: color-mix(in srgb, var(--dylo-muted) 35%, transparent);
  border-radius: 3px;
}
.NotificationBell_list__EoWQD::-webkit-scrollbar-thumb:hover {
  background: color-mix(in srgb, var(--dylo-muted) 55%, transparent);
}

.NotificationBell_item__z4SOH {
  display: flex;
  flex-direction: column;
  gap: 3px;
  width: 100%;
  padding: 9px 10px;
  border: 0;
  border-radius: 10px;
  background: transparent;
  text-align: left;
  cursor: pointer;
  font-family: var(--font-sans);
}
.NotificationBell_item__z4SOH:hover {
  background: color-mix(in srgb, var(--dylo-orange) 8%, transparent);
}
/* Sin leer: barra a la izquierda en lugar de fondo de color.
   Un fondo distinto en la mitad de la lista la vuelve ilegible; una barra se
   distingue de un barrido y no compite con el texto. */
.NotificationBell_itemUnread__CfrUb {
  box-shadow: inset 2px 0 0 var(--dylo-orange);
}
.NotificationBell_itemUnread__CfrUb .NotificationBell_itemTitle__EQckT {
  font-weight: 700;
}

/* ⚠️ \`center\` y no \`baseline\`. Con \`baseline\` el icono cuadrado del tipo de evento se alineaba por la línea
   base del texto y quedaba un par de píxeles bajo, que a 24px se nota como un renglón torcido. */
.NotificationBell_itemTop__-olmI {
  display: flex;
  align-items: center;
  gap: 8px;
}
.NotificationBell_itemTitle__EQckT {
  /* Ocupa el hueco entre el icono y la hora: es lo que mantiene la hora pegada a la derecha ahora que
     \`justify-content: space-between\` ya no aplica con tres hijos. */
  flex: 1 1 auto;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--dylo-ink);
  min-width: 0;
}
.NotificationBell_itemWhen__HzWp\\+ {
  flex: 0 0 auto;
  font-size: 10.5px;
  color: var(--dylo-muted);
  white-space: nowrap;
}
.NotificationBell_itemBody__1PZl1 {
  font-size: 11.5px;
  line-height: 1.45;
  color: var(--dylo-muted);
}
.NotificationBell_itemTag__16t6X {
  align-self: flex-start;
  margin-top: 2px;
  font-size: 9.5px;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  padding: 1px 6px;
  border-radius: 999px;
  color: var(--dylo-orange);
  border: 1px solid color-mix(in srgb, var(--dylo-orange) 45%, transparent);
}

.NotificationBell_empty__QCUzG {
  margin: 0;
  padding: 20px 14px;
  text-align: center;
  font-family: var(--font-sans);
  font-size: 12px;
  line-height: 1.5;
  color: var(--dylo-muted);
}

/*
  Salida a la bandeja completa. Va pegada al borde inferior del panel y con separador
  arriba: es una acción del panel, no un aviso más de la lista, y sin la línea se leería
  como el último renglón.

  ⚠️ \`box-sizing\` explícito. Este proyecto no lo declara de forma global —cada componente
  lo hace por su cuenta— así que \`width: 100%\` con relleno se saldría del panel.
*/
.NotificationBell_footer__Wx2oH {
  box-sizing: border-box;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  appearance: none;
  cursor: pointer;
  padding: 11px 14px;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--dylo-orange);
  background: transparent;
  border: 0;
  border-top: 1px solid var(--dylo-border);
  border-radius: 0 0 12px 12px;
  transition: background 0.16s ease;
}
.NotificationBell_footer__Wx2oH:hover {
  background: color-mix(in srgb, var(--dylo-orange) 8%, transparent);
}

/* =====================================================================
   MICROANIMACIONES Y LENGUAJE VISUAL DEL PANEL

   🔑 Los tonos son los MISMOS que la página de la bandeja, y salen del mismo archivo de TypeScript
   (\`notifications/visuals.tsx\`). Lo que se duplica aquí son las clases de CSS, no el criterio: los módulos de
   estilos tienen alcance propio, así que una clase de la página no se puede resolver desde aquí.
   ===================================================================== */

/* El globo late UNA vez cuando el conteo sube. Es la única señal de que llegó algo mientras la persona estaba
   en otra pantalla: el sondeo es cada minuto, así que sin esto el número cambia en silencio. */
.NotificationBell_badgePulse__yDLDp {
  animation: NotificationBell_badgePop__w52MU 1.3s cubic-bezier(0.22, 0.8, 0.3, 1) 1;
}
@keyframes NotificationBell_badgePop__w52MU {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 color-mix(in srgb, var(--dylo-orange) 60%, transparent);
  }
  25% {
    transform: scale(1.35);
  }
  50% {
    transform: scale(1);
    box-shadow: 0 0 0 8px color-mix(in srgb, var(--dylo-orange) 0%, transparent);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 transparent;
  }
}

/*
  📌 **El panel ya tenía su entrada** (\`bell-in\`, línea 61) con el mismo \`transform-origin: bottom left\`. Aquí
  había una segunda regla \`.panel\` que la repetía con otra curva: dos animaciones para lo mismo, y la de abajo
  ganando por orden. Se quitó en lugar de dejarla — un duplicado así es la forma en que un ajuste futuro se
  aplica al bloque equivocado y "no hace nada".
*/

/* Entrada escalonada de los renglones, con el retraso que manda el componente. */
.NotificationBell_item__z4SOH {
  animation: NotificationBell_itemIn__0\\+77g 0.26s cubic-bezier(0.22, 0.8, 0.3, 1) both;
  animation-delay: var(--item-delay, 0ms);
  transition: background 0.16s ease, border-color 0.16s ease;
}
@keyframes NotificationBell_itemIn__0\\+77g {
  from {
    opacity: 0;
    transform: translateX(-6px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}

/* ===== Icono del tipo de evento ===== */

.NotificationBell_itemIcon__YD6RD {
  display: grid;
  place-items: center;
  width: 24px;
  height: 24px;
  flex: 0 0 24px;
  border-radius: 8px;
}
.NotificationBell_tone_moved__zq\\+6Y {
  color: var(--dylo-teal-500);
  background: color-mix(in srgb, var(--dylo-teal-500) 12%, transparent);
}
.NotificationBell_tone_late__lZQrs {
  color: var(--dylo-danger);
  background: color-mix(in srgb, var(--dylo-danger) 12%, transparent);
}
.NotificationBell_tone_docs__6TZhV {
  color: var(--dylo-warning);
  background: color-mix(in srgb, var(--dylo-warning) 14%, transparent);
}
.NotificationBell_tone_note__aEh4b {
  color: var(--dylo-blue-500);
  background: color-mix(in srgb, var(--dylo-blue-500) 12%, transparent);
}
.NotificationBell_tone_system__eqt-N {
  color: var(--dylo-muted);
  background: var(--dylo-surface-2);
}

/* ===== Insignias de estatus y modalidad ===== */

.NotificationBell_itemChips__Ng6HQ {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  margin-top: 2px;
}
/*
  🔄 15-oct-2026: el color del estatus llega del componente en \`--status-color\`, y es EL MISMO de la tabla de cargas
  y sus tarjetas (\`statusMeaning\`, en \`notifications/visuals.tsx\`). El texto mezcla ese color con la tinta del tema
  (\`--dylo-tint-text\`) para leerse en claro y en oscuro. Sin estatus reconocido queda en el gris de la plataforma.
*/
.NotificationBell_chip__QiDzt {
  font-size: 10.5px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 999px;
  color: color-mix(
    in srgb,
    var(--status-color, var(--dylo-muted)) var(--dylo-tint-text, 70%),
    var(--dylo-ink)
  );
  background: color-mix(in srgb, var(--status-color, var(--dylo-muted)) 14%, transparent);
  border: 1px solid color-mix(in srgb, var(--status-color, var(--dylo-muted)) 36%, transparent);
}
.NotificationBell_mode__Q\\+JGC {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 9.5px;
  font-weight: 700;
  letter-spacing: 0.5px;
  padding: 2px 6px;
  border-radius: 5px;
  color: var(--dylo-muted);
  background: var(--dylo-surface-2);
  border: 1px solid var(--dylo-border);
}

/* ===== Movimiento reducido =====
   En un solo bloque, por lo mismo que en la página: repartirlo garantiza que la próxima animación se olvide
   de respetarlo. */
@media (prefers-reduced-motion: reduce) {
  .NotificationBell_badgePulse__yDLDp,
  .NotificationBell_panel__UCTtV,
  .NotificationBell_item__z4SOH {
    animation: none;
  }
}

`, "",{"version":3,"sources":["webpack://./src/v2/layout/NotificationBell.module.css"],"names":[],"mappings":"AAAA;;;;;;EAME;;AAEF;EACE,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,6BAA6B;EAC7B,kDAAkD;EAClD,kBAAkB;AACpB;AACA;EACE,qEAAqE;EACrE,sBAAsB;AACxB;;AAEA;;qDAEqD;AACrD;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,8BAA8B;EAC9B,WAAW;EACX,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB;wBACsB;EACtB,iEAAiE;AACnE;;AAEA;EACE,eAAe;EACf,aAAa;EACb,YAAY;EACZ,qGAAqG;EACrG,6BAA6B;EAC7B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,4CAA4C;EAC5C,mBAAmB;EACnB,2CAA2C;EAC3C,6BAA6B;EAC7B,mFAA2D;EAC3D,gBAAgB;AAClB;;AAEA;EACE,OAAO,UAAU,EAAE,sCAAsC,EAAE;EAC3D,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACtD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mDAAmD;AACrD;AACA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,SAAS;EACT,uBAAuB;EACvB,UAAU;EACV,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,0EAA0E;EAC1E,4BAA4B;EAC5B,qGAAqG;EACrG,qBAAqB;EACrB,mFAAmF;AACrF;AACA;EACE,UAAU;AACZ;AACA;EACE,uBAAuB;AACzB;AACA;EACE,kEAAkE;EAClE,kBAAkB;AACpB;AACA;EACE,kEAAkE;AACpE;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,kEAAkE;AACpE;AACA;;uDAEuD;AACvD;EACE,4CAA4C;AAC9C;AACA;EACE,gBAAgB;AAClB;;AAEA;iGACiG;AACjG;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE;oEACkE;EAClE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,yEAAyE;AAC3E;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;;;;;;;CAOC;AACD;EACE,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,SAAS;EACT,wCAAwC;EACxC,4BAA4B;EAC5B,iCAAiC;AACnC;AACA;EACE,kEAAkE;AACpE;;AAEA;;;;;;0EAM0E;;AAE1E;+FAC+F;AAC/F;EACE,kFAA0D;AAC5D;AACA;EACE;IACE,mBAAmB;IACnB,2EAA2E;EAC7E;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;IACnB,4EAA4E;EAC9E;EACA;IACE,mBAAmB;IACnB,+BAA+B;EACjC;AACF;;AAEA;;;;;CAKC;;AAED,iFAAiF;AACjF;EACE,qFAA4D;EAC5D,uCAAuC;EACvC,0DAA0D;AAC5D;AACA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,eAAe;EACjB;AACF;;AAEA,yCAAyC;;AAEzC;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,qEAAqE;AACvE;AACA;EACE,yBAAyB;EACzB,mEAAmE;AACrE;AACA;EACE,0BAA0B;EAC1B,oEAAoE;AACtE;AACA;EACE,2BAA2B;EAC3B,qEAAqE;AACvE;AACA;EACE,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA,iDAAiD;;AAEjD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;AACA;;;;CAIC;AACD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB;;;;GAIC;EACD,uFAAuF;EACvF,6FAA6F;AAC/F;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;;mBAEmB;AACnB;EACE;;;IAGE,eAAe;EACjB;AACF","sourcesContent":["/*\n * Bandeja del sidebar.\n *\n * Copia el marco de `UserMenu.module.css` -mismo ancho de panel, misma sombra,\n * misma animacion- para que los dos desplegables del pie se sientan del mismo\n * sitio. Lo que cambia es el contenido, no el envoltorio.\n */\n\n.trigger {\n  border: none;\n  background: transparent;\n  text-align: left;\n  font-family: var(--font-sans);\n  /* El globo se posiciona contra este contenedor. */\n  position: relative;\n}\n.triggerOpen {\n  background: color-mix(in srgb, var(--dylo-teal-700) 12%, transparent);\n  color: var(--dylo-ink);\n}\n\n/* Globo con el conteo, encima del icono.\n   Va sobre el icono y no junto a la etiqueta porque la etiqueta desaparece con el\n   sidebar colapsado, que es el estado por omision. */\n.badge {\n  position: absolute;\n  top: -5px;\n  right: -7px;\n  min-width: 16px;\n  height: 16px;\n  padding: 0 4px;\n  border-radius: 999px;\n  background: var(--dylo-orange);\n  color: #fff;\n  font-family: var(--font-sans);\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 16px;\n  text-align: center;\n  /* Contorno del color del sidebar para que el globo se separe del icono sin\n     necesitar sombra. */\n  box-shadow: 0 0 0 2px var(--dylo-sidebar-bg, var(--dylo-surface));\n}\n\n.panel {\n  position: fixed;\n  z-index: 1200;\n  width: 330px;\n  /* En un teléfono angosto no pasa del ancho de la pantalla (21-oct-2026). Ver `popoverPosition.ts`. */\n  max-width: calc(100vw - 24px);\n  max-height: 60vh;\n  display: flex;\n  flex-direction: column;\n  background: var(--dylo-surface);\n  border: 1px solid var(--dylo-surface-border);\n  border-radius: 14px;\n  box-shadow: 0 12px 34px rgba(0, 0, 0, 0.28);\n  transform-origin: bottom left;\n  animation: bell-in 0.18s cubic-bezier(0.16, 1, 0.3, 1) both;\n  overflow: hidden;\n}\n\n@keyframes bell-in {\n  from { opacity: 0; transform: translateY(6px) scale(0.97); }\n  to { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n.head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 11px 13px;\n  border-bottom: 1px solid var(--dylo-surface-border);\n}\n.headTitle {\n  font-family: var(--font-sans);\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--dylo-ink);\n}\n.markAll {\n  border: 0;\n  background: transparent;\n  padding: 0;\n  font-family: var(--font-sans);\n  font-size: 11.5px;\n  font-weight: 600;\n  color: var(--dylo-orange);\n  cursor: pointer;\n}\n.markAll:hover {\n  text-decoration: underline;\n}\n\n.list {\n  overflow-y: auto;\n  padding: 5px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  /* Al llegar al final de la lista, la rueda no mueve la página de atrás. */\n  overscroll-behavior: contain;\n  /* 🔄 15-oct-2026: la barra de la plataforma (la de los modales y las tablas), no la del navegador. */\n  scrollbar-width: thin;\n  scrollbar-color: color-mix(in srgb, var(--dylo-muted) 35%, transparent) transparent;\n}\n.list::-webkit-scrollbar {\n  width: 6px;\n}\n.list::-webkit-scrollbar-track {\n  background: transparent;\n}\n.list::-webkit-scrollbar-thumb {\n  background: color-mix(in srgb, var(--dylo-muted) 35%, transparent);\n  border-radius: 3px;\n}\n.list::-webkit-scrollbar-thumb:hover {\n  background: color-mix(in srgb, var(--dylo-muted) 55%, transparent);\n}\n\n.item {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  width: 100%;\n  padding: 9px 10px;\n  border: 0;\n  border-radius: 10px;\n  background: transparent;\n  text-align: left;\n  cursor: pointer;\n  font-family: var(--font-sans);\n}\n.item:hover {\n  background: color-mix(in srgb, var(--dylo-orange) 8%, transparent);\n}\n/* Sin leer: barra a la izquierda en lugar de fondo de color.\n   Un fondo distinto en la mitad de la lista la vuelve ilegible; una barra se\n   distingue de un barrido y no compite con el texto. */\n.itemUnread {\n  box-shadow: inset 2px 0 0 var(--dylo-orange);\n}\n.itemUnread .itemTitle {\n  font-weight: 700;\n}\n\n/* ⚠️ `center` y no `baseline`. Con `baseline` el icono cuadrado del tipo de evento se alineaba por la línea\n   base del texto y quedaba un par de píxeles bajo, que a 24px se nota como un renglón torcido. */\n.itemTop {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.itemTitle {\n  /* Ocupa el hueco entre el icono y la hora: es lo que mantiene la hora pegada a la derecha ahora que\n     `justify-content: space-between` ya no aplica con tres hijos. */\n  flex: 1 1 auto;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--dylo-ink);\n  min-width: 0;\n}\n.itemWhen {\n  flex: 0 0 auto;\n  font-size: 10.5px;\n  color: var(--dylo-muted);\n  white-space: nowrap;\n}\n.itemBody {\n  font-size: 11.5px;\n  line-height: 1.45;\n  color: var(--dylo-muted);\n}\n.itemTag {\n  align-self: flex-start;\n  margin-top: 2px;\n  font-size: 9.5px;\n  font-weight: 700;\n  letter-spacing: 0.4px;\n  text-transform: uppercase;\n  padding: 1px 6px;\n  border-radius: 999px;\n  color: var(--dylo-orange);\n  border: 1px solid color-mix(in srgb, var(--dylo-orange) 45%, transparent);\n}\n\n.empty {\n  margin: 0;\n  padding: 20px 14px;\n  text-align: center;\n  font-family: var(--font-sans);\n  font-size: 12px;\n  line-height: 1.5;\n  color: var(--dylo-muted);\n}\n\n/*\n  Salida a la bandeja completa. Va pegada al borde inferior del panel y con separador\n  arriba: es una acción del panel, no un aviso más de la lista, y sin la línea se leería\n  como el último renglón.\n\n  ⚠️ `box-sizing` explícito. Este proyecto no lo declara de forma global —cada componente\n  lo hace por su cuenta— así que `width: 100%` con relleno se saldría del panel.\n*/\n.footer {\n  box-sizing: border-box;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  appearance: none;\n  cursor: pointer;\n  padding: 11px 14px;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--dylo-orange);\n  background: transparent;\n  border: 0;\n  border-top: 1px solid var(--dylo-border);\n  border-radius: 0 0 12px 12px;\n  transition: background 0.16s ease;\n}\n.footer:hover {\n  background: color-mix(in srgb, var(--dylo-orange) 8%, transparent);\n}\n\n/* =====================================================================\n   MICROANIMACIONES Y LENGUAJE VISUAL DEL PANEL\n\n   🔑 Los tonos son los MISMOS que la página de la bandeja, y salen del mismo archivo de TypeScript\n   (`notifications/visuals.tsx`). Lo que se duplica aquí son las clases de CSS, no el criterio: los módulos de\n   estilos tienen alcance propio, así que una clase de la página no se puede resolver desde aquí.\n   ===================================================================== */\n\n/* El globo late UNA vez cuando el conteo sube. Es la única señal de que llegó algo mientras la persona estaba\n   en otra pantalla: el sondeo es cada minuto, así que sin esto el número cambia en silencio. */\n.badgePulse {\n  animation: badgePop 1.3s cubic-bezier(0.22, 0.8, 0.3, 1) 1;\n}\n@keyframes badgePop {\n  0% {\n    transform: scale(1);\n    box-shadow: 0 0 0 0 color-mix(in srgb, var(--dylo-orange) 60%, transparent);\n  }\n  25% {\n    transform: scale(1.35);\n  }\n  50% {\n    transform: scale(1);\n    box-shadow: 0 0 0 8px color-mix(in srgb, var(--dylo-orange) 0%, transparent);\n  }\n  100% {\n    transform: scale(1);\n    box-shadow: 0 0 0 0 transparent;\n  }\n}\n\n/*\n  📌 **El panel ya tenía su entrada** (`bell-in`, línea 61) con el mismo `transform-origin: bottom left`. Aquí\n  había una segunda regla `.panel` que la repetía con otra curva: dos animaciones para lo mismo, y la de abajo\n  ganando por orden. Se quitó en lugar de dejarla — un duplicado así es la forma en que un ajuste futuro se\n  aplica al bloque equivocado y \"no hace nada\".\n*/\n\n/* Entrada escalonada de los renglones, con el retraso que manda el componente. */\n.item {\n  animation: itemIn 0.26s cubic-bezier(0.22, 0.8, 0.3, 1) both;\n  animation-delay: var(--item-delay, 0ms);\n  transition: background 0.16s ease, border-color 0.16s ease;\n}\n@keyframes itemIn {\n  from {\n    opacity: 0;\n    transform: translateX(-6px);\n  }\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n/* ===== Icono del tipo de evento ===== */\n\n.itemIcon {\n  display: grid;\n  place-items: center;\n  width: 24px;\n  height: 24px;\n  flex: 0 0 24px;\n  border-radius: 8px;\n}\n.tone_moved {\n  color: var(--dylo-teal-500);\n  background: color-mix(in srgb, var(--dylo-teal-500) 12%, transparent);\n}\n.tone_late {\n  color: var(--dylo-danger);\n  background: color-mix(in srgb, var(--dylo-danger) 12%, transparent);\n}\n.tone_docs {\n  color: var(--dylo-warning);\n  background: color-mix(in srgb, var(--dylo-warning) 14%, transparent);\n}\n.tone_note {\n  color: var(--dylo-blue-500);\n  background: color-mix(in srgb, var(--dylo-blue-500) 12%, transparent);\n}\n.tone_system {\n  color: var(--dylo-muted);\n  background: var(--dylo-surface-2);\n}\n\n/* ===== Insignias de estatus y modalidad ===== */\n\n.itemChips {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-wrap: wrap;\n  margin-top: 2px;\n}\n/*\n  🔄 15-oct-2026: el color del estatus llega del componente en `--status-color`, y es EL MISMO de la tabla de cargas\n  y sus tarjetas (`statusMeaning`, en `notifications/visuals.tsx`). El texto mezcla ese color con la tinta del tema\n  (`--dylo-tint-text`) para leerse en claro y en oscuro. Sin estatus reconocido queda en el gris de la plataforma.\n*/\n.chip {\n  font-size: 10.5px;\n  font-weight: 700;\n  padding: 2px 8px;\n  border-radius: 999px;\n  color: color-mix(\n    in srgb,\n    var(--status-color, var(--dylo-muted)) var(--dylo-tint-text, 70%),\n    var(--dylo-ink)\n  );\n  background: color-mix(in srgb, var(--status-color, var(--dylo-muted)) 14%, transparent);\n  border: 1px solid color-mix(in srgb, var(--status-color, var(--dylo-muted)) 36%, transparent);\n}\n.mode {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  font-size: 9.5px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  padding: 2px 6px;\n  border-radius: 5px;\n  color: var(--dylo-muted);\n  background: var(--dylo-surface-2);\n  border: 1px solid var(--dylo-border);\n}\n\n/* ===== Movimiento reducido =====\n   En un solo bloque, por lo mismo que en la página: repartirlo garantiza que la próxima animación se olvide\n   de respetarlo. */\n@media (prefers-reduced-motion: reduce) {\n  .badgePulse,\n  .panel,\n  .item {\n    animation: none;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"trigger": `NotificationBell_trigger__TRjmz`,
	"triggerOpen": `NotificationBell_triggerOpen__Qc71v`,
	"badge": `NotificationBell_badge__Jktys`,
	"panel": `NotificationBell_panel__UCTtV`,
	"bell-in": `NotificationBell_bell-in__74cQA`,
	"head": `NotificationBell_head__1NlTC`,
	"headTitle": `NotificationBell_headTitle__VmCzh`,
	"markAll": `NotificationBell_markAll__VFrhW`,
	"list": `NotificationBell_list__EoWQD`,
	"item": `NotificationBell_item__z4SOH`,
	"itemUnread": `NotificationBell_itemUnread__CfrUb`,
	"itemTitle": `NotificationBell_itemTitle__EQckT`,
	"itemTop": `NotificationBell_itemTop__-olmI`,
	"itemWhen": `NotificationBell_itemWhen__HzWp+`,
	"itemBody": `NotificationBell_itemBody__1PZl1`,
	"itemTag": `NotificationBell_itemTag__16t6X`,
	"empty": `NotificationBell_empty__QCUzG`,
	"footer": `NotificationBell_footer__Wx2oH`,
	"badgePulse": `NotificationBell_badgePulse__yDLDp`,
	"badgePop": `NotificationBell_badgePop__w52MU`,
	"itemIn": `NotificationBell_itemIn__0+77g`,
	"itemIcon": `NotificationBell_itemIcon__YD6RD`,
	"tone_moved": `NotificationBell_tone_moved__zq+6Y`,
	"tone_late": `NotificationBell_tone_late__lZQrs`,
	"tone_docs": `NotificationBell_tone_docs__6TZhV`,
	"tone_note": `NotificationBell_tone_note__aEh4b`,
	"tone_system": `NotificationBell_tone_system__eqt-N`,
	"itemChips": `NotificationBell_itemChips__Ng6HQ`,
	"chip": `NotificationBell_chip__QiDzt`,
	"mode": `NotificationBell_mode__Q+JGC`
};
export default ___CSS_LOADER_EXPORT___;
